import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { LocaleProvider } from "./i18n/LocaleProvider";
import { LocaleRouteSync } from "./i18n/LocaleRouteSync";
import { AppRoutes } from "./routes/AppRoutes";
import { ScrollToTop } from "./routes/ScrollToTop";
import { GoatCounterAnalytics } from "./seo/GoatCounterAnalytics";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <LocaleProvider>
        <LocaleRouteSync />
        <ScrollToTop />
        <GoatCounterAnalytics />
        <AppRoutes />
      </LocaleProvider>
    </BrowserRouter>
  </React.StrictMode>
);
